import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export default styled(Link)((props) => ({
  color: props.theme.colors.lightBlue,
  fontSize: '14px',
}));
